/* eslint-disable max-classes-per-file */
type TErrorType = "http" | "abort" | "fastrpc" | "timeout" | "unknown";
export class HTTPError extends Error {
	status: number;

	message: string;

	correlationId: string;

	instanceId: string;

	constructor(status: number, message: string, correlationId = "") {
		super(message);
		this.message = message;
		this.name = "HTTPError";
		this.status = status;
		this.correlationId = correlationId;
	}
}

export class FastRPCError extends Error {
	status: number;

	message: string;

	// FIXME: lepsi typ?
	data: object | undefined;

	constructor(status: number, message: string, data?: object) {
		super(message);
		this.status = status;
		this.name = "FastRPCError";
		this.message = message;
		if (data) {
			this.data = data;
		}
	}
}

export class TimeoutError extends Error {
	message: string;

	correlationId: string;

	instanceId: string;

	constructor(correlationId = "") {
		const message = "Request timed out";

		super(message);
		this.name = "TimeoutError";
		this.message = message;
		this.correlationId = correlationId;
	}
}

export class AbortError extends Error {
	message: string;

	correlationId: string;

	instanceId: string;

	constructor(correlationId = "") {
		const message = "Request aborted";

		super(message);
		this.name = "AbortError";
		this.message = message;
		this.correlationId = correlationId;
	}
}

export function getFrpcErrorType(error: HTTPError | FastRPCError | TimeoutError | AbortError) {
	let type: TErrorType = "unknown";

	if (error instanceof AbortError) {
		type = "abort";
	} else if (error instanceof FastRPCError) {
		type = "fastrpc";
	} else if (error instanceof TimeoutError) {
		type = "timeout";
	} else if (error instanceof HTTPError) {
		type = "http";
	}

	return type;
}
